<template>
  <a-modal
    width="80%"
    wrapClassName="full-modal"
    :dialog-style="{ top: '20px' }"
    :visible="visible"
    :confirmLoading="confirmLoading"

    okText="提交"
    cancelText="取消"
    @ok="handlerSubmit"
    @cancel="() => $emit('hideModal')"

    :afterClose="afterHideEditModal"
  >
    <a-affix
      :offsetTop="16"
      style="height: 74px; width: 100%">
      <div class="btn-container">
        <a-button
          type="primary"
          style="margin-right: 5px; "
          @click="() => (drawer = true)">
          查看 JSON
        </a-button>
        <a-button
          type="primary"
          @click="saveAsPng">
          保存图片
        </a-button>
        <div class="slider">
          <a-button
            type="primary"
            icon="minus"
            style="margin-right: 16px; width: 32px"
            @click="zoom -= 0.1" />
          <a-slider
            style="width: 189px"
            v-model="zoom"
            :marks="marks"
            :min="0.1"
            :max="5"
            :step="0.1"
            height="200px" />
          <a-button
            type="primary"
            icon="plus"
            style="margin-left: 16px; width: 32px"
            @click="zoom += 0.1" />
        </div>
      </div>
    </a-affix>
    <div
      class="affix-container"
      :style="`transform: scale(${zoom})`"
      style="transform-origin: 0 0">
      <sc-workflow
        class="workflow"
        ref="workflowRef"
        id="content-to-capture"
        :model-value="nodeConfig.nodeConfig" />
      <a-drawer
        v-model="drawer"
        size="500px"
        class="drawer"
        :append-to-body="true"
        :modal="false"
        :with-header="false">
        <div style="height: 100vh">
          <div style="padding: 1px; background-color: #3883fa">
            <a-button
              type="primary"
              plain
              @click="copyParseJson">
              复制格式化后的 JSON
            </a-button>
            <a-button
              type="primary"
              plain
              @click="copyJson">
              复制压缩后的 JSON
            </a-button>
            <a-button
              type="primary"
              plain
              @click="drawer = false">
              关闭弹窗
            </a-button>
          </div>
          <json-editor-vue
            class="editor"
            language="zh-CN"
            current-mode="view"
            v-model="nodeConfig" />
        </div>
      </a-drawer>
    </div>
  </a-modal>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import html2canvas from 'html2canvas'
import scWorkflow from './scWorkflow/index'

const zoom = ref(1)
const marks = reactive({
  0.1: 'min',
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: 'max'
})

const drawer = ref(false)
const data = ref()

const handleWeel = (e) => {
  e.preventDefault()
  if (e.wheelDelta < 0) {
    zoom.value -= 0.1
  } else {
    zoom.value += 0.1
  }

  if (zoom.value <= 0.1) {
    zoom.value = 0.1
  } else if (zoom.value >= 5) {
    zoom.value = 5
  }
}

// onMounted(() => {
//   document.getElementById('app').onwheel = (e) => handleWeel(e)
// })
export default {
  name: 'WorkFlowModal',
  components:{
    scWorkflow
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    confirmLoading: {
      type: Boolean,
      default: false
    },
    modelValue: { type: Object, default: () => {} }
  },
  data (){
    return {
      zoom: zoom,
      drawer: false,
      nodeConfig: {},
      marks:{
        0.1: 'min',
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: 'max'
      },
    }
  },
  watch: {
    visible(val){
      console.log(val)
      // this.nodeConfig = val
    },
  },
  methods: {
    async copyParseJson(){
      await toClipboard(JSON.stringify({}, null, '  '))
    },
    async copyJson(){
      await toClipboard(JSON.stringify({}))
    },
    async saveAsPng(){
      const element = document.getElementById('content-to-capture')
      element.parentElement.style.transform = 'scale(1)'
      const canvas = await html2canvas(element, {
        backgroundColor: '#efefef'
      })
      const image = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
      let link = document.createElement('a')
      link.download = `flowlong-${Date.now()}.png`
      link.href = image
      link.click()
    },
    handlerSubmit() {
    },
    // 生成设备标组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.confirmLoading = false
    },
  }
}
</script>

<style scoped>
:root {
  --el-drawer-padding-primary: 0;
}

body {
  margin: 0;
  background-color: #efefef;
}

.affix-container {
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
}

.editor {
  width: 500px;
  height: calc(100vh - 36px);
}

.editor .jsoneditor-poweredBy,
.editor .jsoneditor-transform,
.editor .jsoneditor-repair,
.editor .full-screen {
  display: none !important;
}

.workflow {
  padding: 10px;
}

.jsoneditor-menu > button.jsoneditor-copy {
  background-position: -48px 0px;
}

.el-drawer__body {
  padding: 0 !important;
}

.btn-container {
  display: flex;
  height: 42px;
  margin-left: 16px;
}

.slider {
  margin-left: 16px;
  width: 300px;
  display: flex;
}
</style>
